export default {
  remote: 'simplify_hub_profile_mfe',
  name: 'profile',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: {
    localhost: 'http://localhost:4344/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1100769639/simplify-profile/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1100769639/simplify-profile/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1100769639/simplify-profile/v1/mf2/mf-manifest.json',
  },
};
